<template>
  <div class="content-main">
    <div class="section-header">
      <div class="section-header-badge">
        <img src="@/assets/images/logo.png" alt="eSUS Feedback" />
        <!-- <b-dropdown id="dropdown-1" text="Dropdown Button" no-caret>
          <template #button-content>
            <i class="icofont-alarm"></i>
            <span>3</span>
          </template>
          <b-dropdown-item>First Action</b-dropdown-item>
          <b-dropdown-item>Second Action</b-dropdown-item>
        </b-dropdown> -->
      </div>
      <div class="section-header-search">
        <!-- <form class="navbar-form" role="search">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Search"
              name="q"
            />
            <div class="input-group-btn">
              <button class="btn btn-default" type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </div>
        </form> -->
      </div>
      <div class="container-button-login">
        <div class="section-header-login">
          <a
            href="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-3831"
            target="_blank"
            class="button-new"
          >
            NEW
          </a>
        </div>

        <div class="section-header-login">
          <a href="/demonstracao" target="_blank" class="button-demonstracao">
            <i class="icofont-user-alt-7"></i>
            Demonstração
          </a>
        </div>

        <div class="section-header-login">
          <a href="/login" target="_blank">
            <i class="icofont-user-alt-7"></i>
            Acesso Restrito
          </a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="section-1">
          <div class="section-1-text">
            <h2>Atenção Primária à Saúde</h2>
            <hr />
            <div class="section-1-info">
              <p>
                Um painel de gestão para ajudar profissionais de saúde e
                gestores no atendimento aos
                <strong>requisitos do Cofinanciamento federal da APS</strong>.
                Um sistema de monitoramento e avaliação para ajudar
                profissionais de saúde e gestores no atendimento aos requisitos
                do cofinanciamento federal da APS. O <b>eSUS Feedback</b> é
                dotado de inteligência e usa <b>IA</b> na visualização de dados
                em saúde que auxilia, entre outras coisas, nas ações de:
              </p>
              <div class="row login-cards">
                <div class="col-12 col-lg-6">
                  <div class="media service-box mb-0">
                    <div class="pull-left">
                      <i class="icofont-search"></i>
                    </div>
                    <div class="media-body">
                      <h4 class="media-heading">Monitoramento</h4>
                      <p>
                        Cadastros individuais por Agente Comunitário de Saúde;
                      </p>
                      <p>
                        Avaliação dos resultados dos indicadores de desempenho
                        da APS estratificado por município, equipe e microárea;
                      </p>
                      <p>
                        Monitoramento e avaliação das ações de saúde no
                        território;
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="media service-box mb-0">
                    <div class="pull-left">
                      <i class="icofont-users"></i>
                    </div>
                    <div class="media-body">
                      <h4 class="media-heading">Identificação</h4>
                      <p>Cadastros duplicados de cidadãos;</p>
                      <p>Cidadãos não vinculados às equipes de APS;</p>
                      <p>
                        Cidadãos não vinculados aos Agentes Comunitários de
                        Saúde;
                      </p>
                      <p>Cidadãos que estão com vacinas atrasadas.</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="media service-box mb-0">
                    <div class="pull-left">
                      <i class="icofont-list"></i>
                    </div>
                    <div class="media-body">
                      <h4 class="media-heading">Acompanhamento</h4>
                      <p>Pessoas visitadas por Agente Comunitário de Saúde;</p>
                      <p>
                        Atendimentos dos profissionais por data e turno nos
                        últimos 30 dias;
                      </p>
                      <p>
                        Envio de dados do aplicativo do Agente Comunitário de
                        Saúde para o sistema e-SUS PEC.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="media service-box mb-0">
                    <div class="pull-left">
                      <i class="icofont-verification-check"></i>
                    </div>
                    <div class="media-body">
                      <h4 class="media-heading">Validação</h4>
                      <p>
                        Profissionais de saúde entre o e-SUS PEC e o SCNES para
                        que os dados sejam enviados com sucesso para o sistema
                        SISAB;
                      </p>
                      <p>
                        Capacidade para mediar a busca ativa em relação aos
                        diversos tipos de serviços disponíveis na APS e filtrado
                        por equipe e microárea.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="section-1-img">
            <img src="../assets/images/realtime.svg" alt="dashboard" />
            <div class="section-1-apps">
              <a
                href="https://play.google.com/store/apps/details?id=br.com.feedback.app"
                target="_blank"
                class="android"
              >
                <i class="icofont-brand-android-robot"></i>
                <span>Disponível na <span>Google Play</span></span>
              </a>
              <a
                href="https://apps.apple.com/br/app/esus-feedback/id1604281527"
                target="_blank"
                class="apple"
              >
                <i class="icofont-brand-apple"></i>
                <span>Disponível na <span>Apple Store</span></span>
              </a>
              <a
                href="https://www.instagram.com/biatic/"
                target="_blank"
                class="instagram"
              >
                <i class="icofont-instagram"></i>
                <span>Siga-nos no <span>Instagram</span></span>
              </a>
              <a
                href="https://www.youtube.com/c/eSUSFeedback"
                target="_blank"
                class="youtube"
              >
                <i class="icofont-youtube-play"></i>
                <span>Siga-nos no <span>Youtube</span></span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 d-none d-sm-block d-lg-block d-xl-block">
        <section class="featured" id="featured">
          <div class="row">
            <div class="col-lg-12">
              <div class="section-title-index">
                <h2>Vínculo e acompanhamento</h2>
              </div>
            </div>
          </div>
          <!-- <splide :options="cardsSplide">
        <splide-slide> -->
          <div class="row login-cards">
            <div
              v-for="(item, index) in vinculoAcompanhamento"
              :key="index"
              class="col-md-4 col-sm-6"
            >
              <div class="media service-box">
                <div class="pull-left">
                  <i :class="item.icon"></i>
                </div>
                <div class="media-body">
                  <h4 class="media-heading">{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- </splide-slide>
        <splide-slide> -->
          <div class="row">
            <div class="col-lg-12">
              <div class="section-title-index">
                <h2>Indicadores de qualidade</h2>
              </div>
            </div>
          </div>
          <div class="row login-cards">
            <div
              v-for="(item, index) in qualidade"
              :key="index"
              class="col-md-4 col-sm-6"
            >
              <div class="media service-box">
                <div class="pull-left">
                  <i :class="item.icon"></i>
                </div>
                <div class="media-body">
                  <h4 class="media-heading">{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- </splide-slide>
        <splide-slide> -->
          <div class="row">
            <div class="col-lg-12">
              <div class="section-title-index">
                <h2>Outras ações</h2>
              </div>
            </div>
          </div>
          <div class="row login-cards">
            <div class="col-md-4 col-sm-6">
              <div class="media service-box">
                <div class="pull-left">
                  <i class="icofont-list"></i>
                </div>
                <div class="media-body">
                  <h4 class="media-heading">Atendimentos no mês</h4>
                  <p>Atendimentos realizados no últimos 30 dias</p>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="media service-box">
                <div class="pull-left">
                  <i class="icofont-loop"></i>
                </div>
                <div class="media-body">
                  <h4 class="media-heading">Envio APP ACS PEC</h4>
                  <p>Última visita do ACS encontrada no PEC</p>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="media service-box">
                <div class="pull-left">
                  <i class="icofont-loop"></i>
                </div>
                <div class="media-body">
                  <h4 class="media-heading">Profissionais PEC CNES</h4>
                  <p>Validação de profissionais entre PEC e CNES</p>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="media service-box">
                <div class="pull-left">
                  <i class="icofont-eye-alt"></i>
                </div>
                <div class="media-body">
                  <h4 class="media-heading">Últimas visualizações</h4>
                  <p>Profissionais que acessaram o eSUS Feedback</p>
                </div>
              </div>
            </div>
          </div>
          <!-- </splide-slide>
      </splide> -->
        </section>
      </div>
    </div>

    <b-modal
      v-model="modalNotification.active"
      id="bv-modal-notification"
      hide-footer
      centered
    >
      <div class="modal-notification-header">
        <h2>
          <i class="icofont-warning-alt"></i>
          Atenção!
        </h2>
        <p>
          No período de <strong>24/01 a 26/01 de 2023</strong>, estaremos
          realizando manutenção no eSUS Feedback (Site e app).
        </p>
        <p>
          Ao tentar acessar os dados e alguma funcionalidade não estiver
          disponível, então retornar no dia seguinte, por gentileza.
        </p>
        <p>
          Essa atualização vai aumentar a capacidade do eSUS Feedback e melhorar
          a velocidade.
        </p>
        <p class="text-center">
          <strong>Atenciosamente, Biatic+ eSUS Feedback.</strong>
        </p>
      </div>
    </b-modal>

    <b-modal v-model="modalShow" size="lg" hide-footer>
      <a href="#">
        <img
          src="../assets/images/cofinanciamento-federal/resultado-municipal-2026-q2.png"
          alt=""
          class="modal-ranking-image"
          style="width: 100%"
          fetchpriority="high"
        />
      </a>
    </b-modal>

    <!-- <chatbot></chatbot> -->
  </div>
</template>

<script>
import Chatbot from '@/components/Chatbot.vue'

export default {
  components: {
    Chatbot,
  },
  data() {
    return {
      modalShow: true,
      modalNotification: {
        active: false,
      },
      qualidade: [
        {
          title: 'Desenvolvimento infantil',
          description: 'Cuidado da Crianças',
          icon: 'icofont-baby',
        },
        {
          title: 'Gestantes e puérperas',
          description: 'Cuidado das gestantes e puérperas',
          icon: 'icofont-baby',
        },
        {
          title: 'Indicadores eSB',
          description: 'Cidadãos acompanhados pela Saúde Bucal',
          icon: 'icofont-tooth',
        },
        {
          title: 'Atendimento hipertensão',
          description: 'Cuidado com os hipertensos',
          icon: 'icofont-blood-drop',
        },
        {
          title: 'Atendimento diabetes',
          description: 'Cuidado com os diabéticos',
          icon: 'icofont-users-alt-4',
        },
        {
          title: 'Saúde da mulher',
          description: 'Cuidado com as mulheres',
          icon: 'icofont-female',
        },
        {
          title: 'Saúde da pessoa idosa',
          description: 'Cuidado dos idosos',
          icon: 'icofont-people',
        },
        {
          title: 'Indicadores eMulti',
          description: 'Cidadãos acompanhados pela equipe multiprofissional',
          icon: 'icofont-duotone icofont-field-group',
        },
        {
          title: 'Outros',
          description: '',
          icon: 'icofont-people',
        },
      ],
      vinculoAcompanhamento: [
        {
          title: 'Cadastros completos por ACS',
          description: 'Cadastro populacional feito pela eSF e/ou eAP',
          icon: 'icofont-people',
        },
        {
          title: 'Cidadãos Duplicados',
          description: 'Pessoas com mais de um cadastro',
          icon: 'icofont-copy-invert',
        },
        {
          title: 'Cidadãos Desvinculados',
          description: 'Cidadãos sem vinculação com qualquer equipe',
          icon: 'icofont-people',
        },
        {
          title: 'Cidadãos visitados',
          description:
            'Última visita realizada por cidadão nos últimos 5 meses',
          icon: 'icofont-users-alt-4',
        },
        {
          title: 'Cidadãos sem ACS',
          description: 'Cidadãos sem vinculação com qualquer ACS',
          icon: 'icofont-users-alt-4',
        },
        {
          title: 'ACS por cidadão',
          description: 'Dados do cidadão (Imprimir cartão SUS, equipe e ACS)',
          icon: 'icofont-users-alt-4',
        },
      ],
    }
  },
  mounted() {
    const plugin = document.createElement('script')
    plugin.setAttribute('src', 'https://www.chatbase.co/embed.min.js')
    plugin.setAttribute('id', 'wVL9rQqWycKPH3nay6WyY')
    plugin.async = true
    document.head.appendChild(plugin)
    window.chatbaseConfig = {
      chatbotId: 'wVL9rQqWycKPH3nay6WyY',
    }
    const button = document.getElementById('chatbase-bubble-button')
    if (button) {
      button.style.transform = 'scale(1)'
    }
  },
  beforeDestroy() {
    const scripts = document.querySelectorAll(
      'script[id="wVL9rQqWycKPH3nay6WyY"]'
    )
    scripts.forEach((script) => {
      if (script.parentNode) {
        script.parentNode.removeChild(script)
      }
    })
    const button = document.getElementById('chatbase-bubble-button')
    if (button) {
      button.style.transform = 'scale(0)'
    }
  },
  methods: {},
}
</script>

<style lang="scss">
$primary-color: #0fafd7;
$secondary-color: #0d98bb;
$service-color: #45aed6;
$text-color: #000;
$white: #fff;
$gray: #ccc;
$light-gray: #eee;
$border-color: #d7d7d7;
$new-color: #ff4d4f;
$instagram-color: #ff3040;
$android-color: #5cb85c;
$youtube-color: red;

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin: 20px 0;

  &-badge {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

    img {
      width: 80px;
    }

    button {
      width: 42px;
      height: 42px;
      border: none;
      font-size: 18px;
    }

    span {
      position: absolute;
      top: -10px;
      right: -10px;
      width: 25px;
      height: 25px;
      padding: 3px;
      border-radius: 32px;
      background-color: $youtube-color;
      color: $white;
      font-size: 13px;
    }
  }

  &-search {
    width: 40%;
  }

  &-login {
    a {
      display: inline-block;
      padding: 10px 30px;
      border-radius: 32px;
      background-color: $primary-color;
      color: $white;
      box-shadow: inset 0 -2px 0 rgb(0 0 0 / 25%);
      font-size: 15px;
      font-weight: 700;
      text-transform: uppercase;
      white-space: nowrap;
      transition: transform 0.2s ease, filter 0.2s ease;

      &:hover {
        color: $white;
        filter: brightness(0.95);
        text-decoration: none;
        transform: translateY(-1px);
      }

      &.button-new {
        padding-right: 20px;
        padding-left: 20px;
        background-color: $new-color;
        color: $white;

        &:hover {
          color: $white;
        }
      }

      &.button-demonstracao {
        background-color: $gray;
        color: $text-color;

        &:hover {
          color: $text-color;
        }
      }
    }
  }
}

.container-button-login {
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-1 {
  display: flex;
  width: 100%;
  margin: 10px 0 0;
  color: $text-color;

  h2 {
    font-size: 2.5795rem;
    font-weight: 600;
    text-align: left;
  }

  &-info {
    margin: 20px auto;
    gap: 15px;

    > img {
      width: 100px;
    }

    > p {
      font-size: 17px;

      ul {
        li {
          position: relative;
          margin-bottom: 10px;
          padding-left: 25px;
          list-style: none;
          font-size: 13px;

          &::before {
            content: '';
            position: absolute;
            top: 10px;
            left: 0;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #4aa5bc;
            transform: translateY(-50%);
            transition: all 0.5s;
          }
        }
      }
    }

    .login-cards {
      .media {
        .media-body {
          p {
            margin-bottom: 5px;
            font-size: 12px;
          }
        }
      }
    }
  }

  &-img {
    > img {
      width: 380px;
      margin: 0 30px;
    }
  }

  &-apps {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 15px;
    margin: 20px auto;

    a {
      display: flex;
      align-items: center;
      width: 180px;
      padding: 10px 23px;
      border-radius: 6px;
      box-shadow: inset 0 -2px 0 rgb(0 0 0 / 25%);
      font-size: 13px;
      font-weight: 400;
      line-height: 40px;

      i {
        padding-right: 6px;
        font-size: 30px;
      }

      span {
        line-height: 20px;

        span {
          display: block;
          font-size: 16px;
          font-weight: 700;
          line-height: 20px;
        }
      }

      &.android {
        background-color: $android-color;
        color: $white;
      }

      &.apple {
        background-color: $gray;
        color: $text-color;
      }

      &.instagram {
        background-color: $instagram-color;
        color: $white;
      }

      &.youtube {
        background-color: $youtube-color;
        color: $white;
      }

      &.android,
      &.apple {
        &:hover {
          color: $text-color;
        }
      }
    }
  }
}

.section-title-index {
  position: relative;
  margin: 0 0 20px;
  padding: 0 0 10px;
  border-top: 0;
  border-bottom: 3px solid $light-gray;
  color: $text-color;
  font-size: 18px;
  font-weight: 600;

  &::before {
    content: '';
    position: absolute;
    bottom: -3px;
    left: 0;
    display: block;
    width: 50px;
    height: 3px;
    background-color: $secondary-color;
  }
}

.section-heading {
  h2 {
    margin-bottom: 30px;
    font-size: 30px;
    font-weight: 700;
    text-align: center;
  }
}

.login-cards {
  .media {
    &.service-box {
      margin: 25px 0;

      .pull-left {
        margin-right: 20px;

        > i {
          position: relative;
          width: 64px;
          height: 64px;
          padding: 20px;
          border-radius: 50px;
          color: $service-color;
          box-shadow: inset 0 0 0 1px $border-color;
          font-size: 30px;
          line-height: 64px;
          text-align: center;
          transition: background-color 400ms;

          &::after {
            content: '';
            position: absolute;
            top: 50%;
            right: -10px;
            width: 20px;
            height: 20px;
            margin-top: -10px;
            border: 4px solid $white;
            border-radius: 20px;
            background-color: $service-color;
          }
        }
      }
    }

    .media-body {
      .media-heading {
        font-size: 18px;
        font-weight: 700;
      }

      p {
        font-size: 14px;
      }
    }
  }
}

/* =======================================================================
   FEATURED
======================================================================= */

.featured {
  padding: 60px 0;

  h1 {
    width: 100%;
    margin: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid $gray;
    font-size: 30px;
  }

  &-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 30px;
    border: 1px solid #deebfd;
    border-radius: 1rem;
    background-color: $white;
    box-shadow: 0 3px 10px rgba(62, 85, 120, 0.045);
    transition: all 0.2s ease 0s;

    i {
      color: $text-color;
      font-size: 55px;
      line-height: 1;
      text-align: center;
    }

    h3 {
      font-size: 18px;
      line-height: 1.2;
      text-align: center;
    }

    &:hover {
      border: 4px solid $primary-color;
      box-shadow: 0 1rem 3rem rgba(31, 45, 61, 0.125) !important;
      transform: translateY(-5px);
    }
  }
}

/* =======================================================================
   MODAL NOTIFICATION
======================================================================= */

.modal-notification-header {
  h2 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;

    i {
      font-size: 62px;
    }
  }

  p {
    font-size: 20px;
  }
}

.modal-ranking-image {
  width: 100%;
}

/* =======================================================================
   RESPONSIVIDADE
======================================================================= */

@media screen and (max-width: 656px) {
  .section-header {
    align-items: flex-start;
    margin: 0 !important;

    &-badge {
      img {
        width: 65px !important;
      }
    }

    &-search {
      display: none;
    }

    &-login {
      a {
        width: 140px;
        padding: 10px 20px !important;
        font-size: 10px !important;
        text-align: center;

        &.button-new {
          width: auto;
          min-width: 60px;
          padding-right: 12px !important;
          padding-left: 12px !important;
        }
      }
    }
  }

  .container-button-login {
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 6px;
  }

  .login-cards {
    .media {
      &.service-box {
        flex-direction: column;
        gap: 30px;
        margin: 25px 0;

        .pull-left {
          align-self: center;
          margin-right: 0;
        }
      }
    }
  }

  .section-1 {
    flex-direction: column;

    h2 {
      font-size: 1.4795rem;
      font-weight: 600;
      text-align: left;
    }

    &-info {
      width: 100%;

      > p {
        font-size: 13px;
      }
    }

    &-img {
      display: flex;
      flex-direction: column;

      > img {
        display: block;
        width: 200px !important;
        margin: 0 auto !important;
      }
    }

    &-apps {
      flex-direction: column;
    }
  }

  .featured {
    padding-top: 0 !important;
  }

  .section-title-index {
    h2 {
      font-size: 22px;
    }
  }
}

@media screen and (min-width: 657px) and (max-width: 807px) {
  .section-1 {
    flex-direction: column;

    h2 {
      font-size: 1.4795rem;
      font-weight: 600;
      text-align: left;
    }

    &-info {
      width: 100%;

      > p {
        font-size: 13px;
      }
    }

    &-img {
      display: flex;
      flex-direction: column;

      > img {
        display: block;
        width: 250px !important;
        margin: 0 auto !important;
      }
    }
  }

  .container-button-login {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}

@media screen and (min-width: 808px) and (max-width: 1023px) {
  .section-1 {
    flex-direction: column;

    h2 {
      font-size: 1.4795rem;
      font-weight: 600;
      text-align: left;
    }

    &-info {
      width: 100%;

      > p {
        font-size: 13px;
      }
    }

    &-img {
      > img {
        display: block;
        width: 250px !important;
        margin: 0 auto !important;
      }
    }
  }

  .container-button-login {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1265px) {
  .section-1 {
    flex-direction: column;

    &-info {
      width: 100%;
    }

    &-img {
      display: flex;

      > img {
        width: 285px;
      }
    }
  }
}
</style>
